module.exports = __webpack_public_path__ + "static/media/ceilingCabinet.0e9cc804.png";